(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-discount-inline"] && !Shopify.designMode) return;
  try {
    (() => {
    const inputSelector = '.nps-cart-discount-inline__input';
    const submitSelector = '.nps-cart-discount-inline__submit';
    const syncInput = (input) => {
      const form = input.closest('.nps-cart-discount-inline__form');
      if (!form) return;
      const ready = input.value.trim().length > 0;
      form.toggleAttribute('data-discount-empty', !ready);
      const button = form.querySelector(submitSelector + ' button');
      if (button) button.disabled = !ready;
    };
    const syncAll = () => document.querySelectorAll(inputSelector).forEach(syncInput);
    const handleInput = (event) => {
      if (event.target instanceof HTMLInputElement && event.target.matches(inputSelector)) {
        syncInput(event.target);
      }
    };
    document.addEventListener('input', handleInput);
    document.addEventListener('change', handleInput);
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const submit = event.target.closest(submitSelector);
      const input = submit?.closest('.nps-cart-discount-inline')?.querySelector(inputSelector);
      if (input && input.value.trim().length === 0) {
        event.preventDefault();
        event.stopPropagation();
        syncInput(input);
      }
    }, true);
    document.addEventListener('DOMContentLoaded', syncAll, { once: true });
    window.addEventListener('pageshow', syncAll);
    syncAll();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nps-background-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nps-background-video')) {
    customElements.define('nps-background-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.button = this.querySelector('button');
        this.userPaused = false;
        this.onToggle = () => { this.userPaused = !this.userPaused; this.update(); };
        this.button?.addEventListener('click', this.onToggle);
        this.inView = false;
        this.desktop = window.matchMedia('(min-width: 768px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.sync = this.update.bind(this);
        this.onPlaying = () => {
          if (this.canPlay()) this.setAttribute('data-playing', '');
        };
        this.onError = () => this.removeAttribute('data-playing');
        this.video.addEventListener('playing', this.onPlaying);
        this.video.addEventListener('error', this.onError);
        this.desktop.addEventListener('change', this.sync);
        this.reducedMotion.addEventListener('change', this.sync);
        document.addEventListener('visibilitychange', this.sync);
        navigator.connection?.addEventListener?.('change', this.sync);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.inView = entries.some((entry) => entry.isIntersecting);
            this.update();
          }, { threshold: 0.01 });
          this.observer.observe(this);
        } else {
          this.onScroll = () => {
            const rect = this.getBoundingClientRect();
            this.inView = rect.bottom > 0 && rect.top < window.innerHeight;
            this.update();
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll);
          this.onScroll();
        }
      }

      canPlay() {
        const viewport = this.dataset.viewport;
        const matchesViewport = viewport === 'all' || (viewport === 'desktop' ? this.desktop.matches : !this.desktop.matches);
        return this.inView && matchesViewport && this.getClientRects().length > 0 && !this.userPaused && !this.reducedMotion.matches && !navigator.connection?.saveData && !document.hidden;
      }

      update() {
        if (this.button) {
          this.button.hidden = this.reducedMotion.matches || !!navigator.connection?.saveData;
          this.button.textContent = this.userPaused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel;
        }
        if (!this.canPlay()) {
          this.unload();
          return;
        }
        const source = this.desktop.matches ? this.dataset.src : this.dataset.mobileSrc;
        if (!source) return;
        if (this.video.getAttribute('src') !== source) {
          this.video.setAttribute('src', source);
          this.video.load();
        }
        this.video.play()?.catch(() => this.removeAttribute('data-playing'));
      }

      unload() {
        this.video.pause();
        this.removeAttribute('data-playing');
        if (this.video.hasAttribute('src')) {
          this.video.removeAttribute('src');
          this.video.load();
        }
      }

      disconnectedCallback() {
        if (!this.video) return;
        this.observer?.disconnect();
        this.button?.removeEventListener('click', this.onToggle);
        this.desktop.removeEventListener('change', this.sync);
        this.reducedMotion.removeEventListener('change', this.sync);
        document.removeEventListener('visibilitychange', this.sync);
        navigator.connection?.removeEventListener?.('change', this.sync);
        if (this.onScroll) {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
        }
        this.video.removeEventListener('playing', this.onPlaying);
        this.video.removeEventListener('error', this.onError);
        this.unload();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
